
import { ConsentData } from './types';

const CONSENT_KEY = 'gdpr-consent';

export const generateSessionId = (): string => {
  return 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
};

export const loadStoredConsent = (): ConsentData | null => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    
    const parsed = JSON.parse(stored);
    
    // Validate the stored consent structure
    if (typeof parsed === 'object' && parsed.timestamp && typeof parsed.necessary === 'boolean') {
      return parsed as ConsentData;
    }
    
    return null;
  } catch (error) {
    return null;
  }
};

export const saveConsent = (consent: ConsentData): void => {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch (error) {
    // Silent error handling
  }
};

export const saveConsentToStorage = saveConsent;

export const clearStoredConsent = (): void => {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch (error) {
    // Silent error handling
  }
};
